import React, {useEffect, useState} from 'react';
import DQProgramRatingView from "../../../views/ver_24.10/ProgramRating/DQRating/DQProgramRating.view";
import {useHistory, useLocation} from "react-router-dom";
import Loader from "../../../ui_library/ver_24.10/Loader/Loader.comp";
import {LOCAL_STORAGE_KEYS, TOAST_TYPES, RATING_TYPE} from "../../../utils/constants";
import {
    createRatingProgramService,
    fetchRatingProgramService, submitProgramDataService,
    uploadMedia
} from "../../../services/rating.service";
import {v4 as uuidv4} from "uuid";
import LoaderBackDropWithPercentage from "../../../components/LoaderWithBackDrop/LoaderBackDropWithPercentage.comp";
import {submitProgramDataPublicService} from "../../../services/rating_public.service";
import {toast} from "../../../utils/utils";

const DQProgramRating = () => {
    const [showLoader, setShowLoader] = useState(false);
    const history = useHistory();
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [uploadedFilesPath, setUploadedFilesPath] = useState([]);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const programId = queryParams.get('programId');

    const uploadSingleFile = async (file, index, totalFiles) => {
        const formData = new FormData();
        formData.append('media', file);

        try {
            const result = await uploadMedia(formData, (progressEvent) => {
                const uploadPercentage = Math.floor(
                    ((progressEvent.loaded / progressEvent.total) * 100) / totalFiles +
                    (index / totalFiles) * 100
                );
                setUploadProgress(uploadPercentage);
            });
            if (result.data) {
                const { media_path } = result.data;
                console.log(`File uploaded: ${media_path}`);
                setUploadedFilesPath((prevFilesPath) => [...prevFilesPath, media_path]);
                setUploadedFiles((prevFiles) => [...prevFiles, file]);
            }
        } catch (e) {
            console.error('Error uploading file', e);
        }
    };

    const data = {
        uploadedFiles,
    };

    // Actions handling business logic
    const actions = {
        uploadFileAction: async (files) => {
            setUploading(true);
            setUploadProgress(0);

            try {
                const totalFiles = files.length;
                for (let i = 0; i < totalFiles; i++) {
                    await uploadSingleFile(files[i], i, totalFiles);
                }
            } catch (error) {
                console.error('Error uploading files:', error);
                alert('An error occurred while uploading the files.');
            } finally {
                setUploading(false);
                setUploadProgress(0);
            }
        },
        deleteFileAction : async (index) => {
            setUploadedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        },
        submitAction : async () => {
            if(uploadedFilesPath.length === 0) {
                return toast(TOAST_TYPES.WARN, "Warning", "Upload at least one word or pdf file!");
            }
            setShowLoader(true);
            try {
                if (programId) {
                    const response = await submitProgramDataService(programId, uploadedFilesPath);
                    if (response.data && response.data.program_application && response.data.added_modules) {
                        console.log('Successfully updated program application:', response.data.program_application);
                        console.log('Successfully added modules:', response.data.added_modules);
                        history.push(`/dq_rating/${response.data.program_application.application_id}/company-program-info`);
                    }
                } else {
                    const response = await createRatingProgramService(RATING_TYPE.DQ_RATING);

                    if (response.data && response.data.program_application) {
                        console.log('Program application created successfully.');
                        console.log(response.data);
                        const result = await submitProgramDataService(response.data.program_application.application_id, uploadedFilesPath);
                        if (result.data && result.data.program_application && result.data.added_modules) {
                            console.log('Successfully updated program application:', result.data.program_application);
                            console.log('Successfully added modules:', result.data.added_modules);
                            history.push(`/dq_rating/${response.data.program_application.application_id}/company-program-info`);
                        }
                    }
                }
            } catch (e) {
                console.error('Error uploading files:', e);
            } finally {
                setShowLoader(false);
            }
        },
    };

    // Configuration options for visual appearance
    const options = {
    };

    if (showLoader) {
        return <Loader />;
    }

    if (uploading)
    {
        return (
            <LoaderBackDropWithPercentage
                loading={uploading}
                value={uploadProgress}
            />
        );
    }

    // Rendering the ProductDisplay view component
    return (
        <div>
            <DQProgramRatingView
                data={data}
                actions={actions}
                options={options}
            />
        </div>
    );
}

export default DQProgramRating;